import React, { Component } from 'react';

class Cliente extends Component {
  constructor(props){
      super(props);
      this.state = {
        cliente: {},
        agente: false,
        agenteTex: 'Convertir en agente'
      }
      fetch('https://ebenlovequickpc.com/API/cliente.php?coduser='+props.match.params.id)
    .then((response => response.json()))
    .then((json) => {
        if(json[0].ROL == 'agente'){
            this.setState({
                agente: true,
                agenteTex: 'Quitar de agente'
            });
        }
        this.setState({
            cliente: json[0]
        });
    });
  }  

  convAgente(){
      var formData = new FormData();
      formData.append('codigoUser', this.state.cliente.CODIGO_USER);
      formData.append('cl', 'update');
      if(this.state.agente){
          formData.append('rol', 'normal');
        this.setState({
            agente: false,
            agenteTex: 'Convertir en agente'
        });
      }else{
        formData.append('rol', 'agente');
          this.setState({
            agente: true,
            agenteTex: 'Quitar de agente'
        });
      }
      fetch('httpS://ebenlovequickpc.com/API/agente.php',{
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then((json) => {
            console.log(json)
        })
    
  }
  render() {
    return (
        <div className="w3-container">
            <br />
            <div className="w3-card w3-round w3-white">
                <div className="w3-container">
                    <h4 className="w3-center">{this.state.cliente.NOMBRE} {this.state.cliente.APELLIDOS} (ID: {this.props.match.params.id})</h4>
                    <p className="w3-center"><img src="https://www.w3schools.com/w3images/avatar3.png" className="w3-circle" style={{height:'106px',width:'106px'}} alt="Avatar" /></p>
                    <hr />
                    <p><i className="fas fa-phone w3-margin-right w3-text-theme"></i> {this.state.cliente.TELEFONO}</p>
                    <p><i className="fas fa-mobile-alt w3-margin-right w3-text-theme"></i> {this.state.cliente.CELULAR}</p>
                    <p><i className="fas fa-address-card w3-margin-right w3-text-theme"></i> {this.state.cliente.NIF}</p>
                    <p><i className="fas fa-envelope w3-margin-right w3-text-theme"></i> {this.state.cliente.CORREO}</p>
                    <p><button className="w3-button w3-border w3-blue w3-round-large" onClick={this.convAgente.bind(this)}>{this.state.agenteTex}</button></p>
                </div>
            </div>
            <br />
            <div className="w3-card w3-round w3-white">
                <div className='w3-container'>
                    <p><i className="fas fa-map-marked-alt w3-margin-right w3-text-theme"></i> {this.state.cliente.DIRECCION}</p>
                    <p><i className="fas fa-map-marked w3-margin-right w3-text-theme"></i> {this.state.cliente.CIUDAD}</p>
                    <p><i className="fas fa-map w3-margin-right w3-text-theme"></i> {this.state.cliente.REFERENCIA}</p>
                </div>
            </div>
        </div>
    );
  }
}

export default Cliente;


// WEBPACK FOOTER //
// ./src/Clientes/Cliente.js